import { Directive, TemplateRef, inject } from "@angular/core";

@Directive({ 
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: "[accordionHeader]" })
export class AccordionHeaderDirective {
    templateRef = inject<TemplateRef<any>>(TemplateRef);
}
